export default {
  oilResultId: { field: 'oilResultId' },
  oilResultCode: { field: 'code' },
  oilResultName: { field: 'oilResultName' }
};
